var ezdia;
(function (ezdia) {
    var configurationWrapper = '#ez-ui-form-configuration-fields-wrapper';
    var container = '#ez-ui-form-configuration-fields';
    var addBtns = '#ez-ui-form-configuration-fields-add-btn';
    var updateBtns = '#ez-form-configuration-update-btn';
    var cancelBtns = '#ez-form-configuration-cancel-btn';
    var frm = 'ez-ui-form-configuration-frm';
    var btnsWrapper = 'ez-form-configuration-btns-wrapper';
    var type = 'form.configuration.fields';
    var rowTemplate = 'base-configuration-form-row';
    var addFieldsTemplate = 'base-configuration-form-select-feilds';
    var handleRemove = '[data-handle="remove"]';
    var handleEditable = '[data-handle="editable"]';
    var disableClass = 'ezdia-form-configuration-disable';
    var rowSelector = '[data-row="row"]';
    var pageParams = {};
    /*
     * private fuctions
     */
    var reset = function (newUi) {
        var display = configurationWrapper + ", #ez-desk-form-group-collapse-link-wrapper, #ez-desk-form-actions-wrapper";
        hideShowDeskForm(display);
        $('#gridForm, #searchFrm, #ez-js-form-item-info-action').addClass(disableClass);
        if (!newUi) {
            $('html, body').animate({
                scrollTop: $(configurationWrapper).offset().top
            }, 1000);
        }
    };
    var createGroups = function () {
        var grp = $.ezdia.groupFormField.create(pageParams.colGroup);
        var tabs = $.ezdia.groupFormField.tabs(pageParams.colGroup);
        $(container).html(grp);
        $('#ez-sys-form-tabs').html(tabs);
    };
    var createFields = function () {
        var template = $.ezdia.template.get(rowTemplate);
        var colModel = $.data(document, 'ez.form.configuration.colModel', []);
        var colName = $.data(document, 'ez.form.configuration.colName', []);
        var index = 0;
        $.ezdia.widgets.load(type);
        $.each(pageParams.colModel, function (i, column) {
            var content = '';
            var colObj = {};
            var obj = {
                column: {},
                value: ''
            };
            if (i === 0 && column.name === 'cb') {
                return;
            }
            colObj = $.extend({}, column, {
                ui_index: index
            });
            obj.column = colObj;
            colModel.push(colObj);
            colName.push(column.name);
            content = getMarkup(obj, template);
            if (column.edittype !== 'composite') {
                $.ezdia.groupFormField.append(column.groupName, content);
            }
            index += 1;
        });
        $.ezdia.widgets.create(type);
        $.ezdia.groupFormField.hide();
    };
    var getMarkup = function (obj, template) {
        var content = '';
        var column = obj.column;
        var json = false;
        if (column.edittype === 'json') {
            column.edittype = 'text';
            json = true;
        }
        if (column.editable) {
            content = $.ezdia.inputs.getMarkup(obj, type, template);
            $.ezdia.widgets.init(obj, type);
        }
        else {
            content = $.ezdia.inputs.readonlyView(obj, type, template);
        }
        if (json) {
            column.edittype = 'json';
        }
        return content;
    };
    var actions = function () {
        $('[data-group="form fields"]').sortable({
            items: rowSelector,
            handle: '[data-handle="move"]',
            cursor: 'move'
        });
        $("#" + frm)
            .off("click." + type)
            .on("click." + type, handleRemove, function click() {
            if ($(this).hasClass('undo')) {
                removeField.call(this);
            }
            else {
                confirmRemoveField.call(this);
            }
        })
            .on("click." + type, handleEditable, function click() {
            toogleField.call(this);
        });
        $(addBtns)
            .off('click')
            .on("click." + type, function click() {
            selectFieldToAdd.call(this);
        })
            .show();
        $(updateBtns)
            .off('click')
            .on("click." + type, function click() {
            update.call(this);
        });
        $(cancelBtns)
            .off('click')
            .on("click." + type, function () {
            var selIds = ezdia.util.getSelectedGridItemsByGridId();
            var grid = $('#grid');
            if (selIds.length === 1) {
                var ids = +selIds[0];
                // Don't remove these line of code.
                grid.jqGrid('setSelection', ids, true);
                grid.jqGrid('setSelection', ids, true);
                // End
            }
            else {
                hideShowDeskForm('');
            }
            $('#gridForm, #searchFrm, #ez-js-form-item-info-action').removeClass(disableClass);
            $('#ez-check-out-btns-wrapper').show();
            $.ezdia.desk.grid.resetGridWidthAndForm(true);
        });
    };
    function confirmRemoveField() {
        var self = this;
        var id = 'ez-form-configuration-remove-dialog';
        var wrapper = $("#" + id);
        if (!wrapper.length) {
            $('body').append($('<div>', {
                id: id,
                html: 'Are you sure to remove this form field?'
            }));
            wrapper = $("#" + id);
        }
        wrapper.dialog({
            modal: true,
            title: 'Remove Form Field',
            width: '300',
            height: '150',
            buttons: [
                {
                    text: 'Cancel',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Delete',
                    click: function () {
                        removeField.call(self);
                        $(this).dialog('close');
                    }
                }
            ]
        });
    }
    function removeField() {
        var colModel = $.data(document, 'ez.form.configuration.colModel');
        var elem = $(this);
        var index = elem.data('index');
        var row = elem.closest(rowSelector);
        var column = colModel[index];
        if (column) {
            column.ui_remove = !column.ui_remove;
            row.toggleClass('ez-form-configuration-field-removed');
        }
    }
    function toogleField() {
        var colModel = $.data(document, 'ez.form.configuration.colModel');
        var template = $.ezdia.template.get(rowTemplate);
        var elem = $(this);
        var index = elem.data('index');
        var row = elem.closest(rowSelector);
        var content = '';
        var column = colModel[index];
        $.ezdia.widgets.load(type);
        if (column) {
            column.editable = !column.editable;
            content = getMarkup({ column: column, value: '' }, template);
            row.replaceWith(content);
            $.ezdia.widgets.create(type);
        }
    }
    function searchInList(containers, typeWrapper) {
        var elem = $(this);
        var typeSelected = typeWrapper.find('li.selected');
        var query = this.value;
        var listItems = null;
        if (!typeSelected.length) {
            return;
        }
        if (typeSelected.length === 1) {
            var value = typeSelected.data('type');
            if (value === 'all') {
                listItems = containers.find('li');
            }
            else {
                listItems = containers.find("li[data-type=\"" + value + "\"]");
            }
        }
        else {
            var dataType_1 = '';
            $.each(typeSelected, function eachtypeSelected() {
                var value = $(this).data('type');
                dataType_1 += ",li[data-type=\"" + value + "\"]";
            });
            listItems = containers.find(dataType_1.substr(1));
        }
        if (query) {
            query = query.toLowerCase();
        }
        listItems.each(function eachlistItems() {
            var text = $(this).text().toLowerCase().trim();
            if (!query) {
                $(this).show();
                elem.val('');
            }
            else if (text.includes(query)) {
                $(this).show();
            }
            else {
                $(this).hide();
            }
        });
    }
    var getAllFields = function () {
        var colName = $.data(document, 'ez.form.configuration.colName');
        var colModel = $.data(document, 'ez.form.configuration.colModel');
        var allFieldsObj = fetchAllAccountFields();
        var allColModel = {
            types: [],
            list: [],
            selectOpt: colModel,
            typeSearchId: 'ez-configuration-form-add-search-feilds-type',
            typeWrapperId: 'ez-configuration-form-add-fields-type-wrapper',
            listSearchId: 'ez-configuration-form-add-search-feilds-list',
            listWrapperId: 'ez-configuration-form-add-fields-add-list-wrapper'
        };
        $.each(allFieldsObj, function (_i, column) {
            var name = column.name, columnType = column.type;
            var newColumn = false;
            if ($.inArray(name, colName) === -1) {
                allColModel.list.push(column);
                newColumn = true;
            }
            if ($.inArray(columnType, allColModel.types) === -1 && newColumn) {
                allColModel.types.push(columnType);
            }
        });
        return $.data(document, 'ez.form.configuration.allColModel', allColModel);
    };
    // eslint-disable-next-line consistent-return
    function addField(listWrapperId) {
        var allColModel = $.data(document, 'ez.form.configuration.allColModel');
        var colModel = $.data(document, 'ez.form.configuration.colModel');
        var obj = {
            success: false,
            url: ''
        };
        var index = $("#" + listWrapperId + " > li.selected").data('index');
        var editable = false;
        var template;
        var content = '';
        var colObj = {};
        if (!index) {
            obj.response = 'Please select field Name.';
            successErrorDialog(obj);
            return false;
        }
        var name = $('#field_insert_name_dropdown').val();
        if (!name) {
            obj.response = 'Please select Insert field before.';
            successErrorDialog(obj);
            return false;
        }
        editable = $('input[name=field_view_option]:checked').val();
        var column = allColModel.list[index];
        $.ezdia.widgets.load(type);
        if (column) {
            template = $.ezdia.template.get(rowTemplate);
            column.editable = !!+editable;
            column.edittype = column.type;
            colObj = $.extend({}, column, {
                ui_index: colModel.length
            });
            content = getMarkup({ column: colObj, value: '' }, template);
            $("#ui-row-" + name).before(content);
            allColModel.list.splice(index, 1);
            colModel.push(column);
            $.ezdia.widgets.create(type);
        }
        $(this).dialog('close');
    }
    function typeClickAction(listWrapper) {
        var self = $(this);
        var types = self.data('type');
        var selectedCls = 'selected';
        if (types === 'all') {
            if (self.hasClass(selectedCls)) {
                self
                    .removeClass(selectedCls)
                    .siblings()
                    .removeClass(selectedCls)
                    .removeClass('selected-sub');
                listWrapper.find('> li').hide();
            }
            else {
                self
                    .addClass(selectedCls)
                    .siblings()
                    .removeClass(selectedCls)
                    .addClass('selected-sub');
                listWrapper.find('> li').show();
            }
        }
        else {
            var typeList = listWrapper.find("> li[data-type=\"" + type + "\"]");
            if (self.hasClass(selectedCls)) {
                typeList.hide();
                self.removeClass(selectedCls);
            }
            else {
                var allSel = self.siblings('[data-type="all"]');
                var isAllSel = allSel.hasClass(selectedCls);
                if (isAllSel) {
                    listWrapper.find('> li').hide();
                    allSel
                        .removeClass(selectedCls)
                        .siblings()
                        .removeClass('selected-sub');
                }
                typeList.show();
                self.addClass(selectedCls);
            }
        }
    }
    function listClickAction() {
        $(this).addClass('selected').siblings().removeClass('selected');
    }
    var showFieldsDialog = function (context) {
        var template = $.ezdia.template.get(addFieldsTemplate);
        var content = template(context);
        var dialogId = 'ez-configuration-form-add-feilds-dialog-wraaper';
        var wrapper = $("#" + dialogId);
        if (!wrapper.length) {
            $('body').append($('<div>', {
                id: dialogId
            }));
            wrapper = $("#" + dialogId);
        }
        wrapper.html(content).dialog({
            modal: true,
            title: 'Add Form Field',
            width: '900',
            height: '450',
            buttons: [
                {
                    text: 'Add Field',
                    id: 'ez-configuration-form-add-feilds-dialog-btn',
                    class: 'btn btn-success',
                    click: function () {
                        addField.call(this, context.listWrapperId);
                    }
                },
                {
                    text: 'Cancel',
                    click: function () {
                        $(this).dialog('close');
                    }
                }
            ]
        });
        var listWrapper = $("#" + context.listWrapperId)
            .sortItems()
            .off('click')
            .on("click." + type, 'li', function click() {
            listClickAction.call(this);
        });
        var typeWrapper = $("#" + context.typeWrapperId)
            .sortItems({ items: '[data-search]' })
            .off('click')
            .on("click." + type, 'li', function click() {
            typeClickAction.call(this, listWrapper);
        });
        $("#" + context.listSearchId).on('keyup', function keyup() {
            searchInList.call(this, listWrapper, typeWrapper);
        });
        $("#" + context.typeSearchId).filterSearch();
    };
    function selectFieldToAdd() {
        var allFieldsObj = $.data(document, 'ez.form.configuration.allColModel');
        if ($.isEmptyObject(allFieldsObj)) {
            allFieldsObj = getAllFields();
        }
        showFieldsDialog.call(this, allFieldsObj);
    }
    /*
     * private AJAX fuctions Start
     */
    function update() {
        pageParams = $.ezdia.config.pageParams;
        var self = $(this).button('loading');
        var colModel = $.data(document, 'ez.form.configuration.colModel');
        var rows = $("#" + frm).find(rowSelector);
        var len = 2;
        var counter = 0;
        var dataObj = {
            editFields: [],
            showFields: []
        };
        var data = "&accountName=" + pageParams.account;
        data += "&role=" + pageParams.role;
        data += "&tab=" + pageParams.role;
        data += '&type=role';
        if (pageParams.tab === 'MyOpenTask') {
            len = 1;
            dataObj = {
                openTaskShowFields: []
            };
            $.each(rows, function eachrows() {
                var index = $(this).data('index');
                var column = colModel[index];
                if (column && !column.ui_remove) {
                    dataObj.openTaskShowFields.push(column.name);
                }
            });
        }
        else {
            $.each(colModel, function (i, column) {
                if (column.ui_remove) {
                    return;
                }
                if (column.editable) {
                    dataObj.editFields.push(column.name);
                }
            });
            $.each(rows, function eachrows() {
                var index = $(this).data('index');
                var column = colModel[index];
                if (column && !column.ui_remove) {
                    dataObj.showFields.push(column.name);
                }
            });
        }
        $.each(dataObj, function (key, value) {
            var sendData = data;
            sendData += "&action=" + key;
            sendData += "&columnValue=" + value.toString();
            counter += 1;
            $.ajax({
                type: 'POST',
                url: 'saveUserSettings.htm',
                data: sendData,
                dataType: 'json',
                async: false,
                success: function (response) {
                    if (len === counter) {
                        self.button('reset');
                        var obj = {
                            response: response.SUCCESS,
                            success: true,
                            url: '',
                            session: true
                        };
                        successErrorDialog(obj);
                    }
                },
                error: function () {
                    $.ezdia.showSuccessError({
                        message: 'Unable to save the data this time.Please try again or <a href="https://app.smartsheet.com/b/form?EQBCT=28e7510ab4534a22bcc7b9103ff1f98b" target="_blank">contact support.</a>',
                        error: true
                    });
                    self.button('reset');
                }
            });
        });
    }
    var fetchAllAccountFields = function () {
        var response = '';
        var data = "accountName=" + pageParams.account;
        data += "&role=" + pageParams.role;
        $.ajax({
            type: 'POST',
            url: 'fetchAllAccountFields.htm',
            data: data,
            dataType: 'json',
            async: false,
            success: function (resp) {
                response = resp;
            },
            error: function (resp) {
                response = resp;
            }
        });
        return response;
    };
    // eslint-disable-next-line import/prefer-default-export
    ezdia.formConfiguration = {
        load: function () {
            $.data(document, 'ez.form.configuration.allColModel', {});
        },
        render: function (newUi) {
            this.load();
            var self = this;
            pageParams = $.ezdia.config.pageParams;
            if (!pageParams.colModel) {
                return;
            }
            $('#ez-check-out-btns-wrapper').hide();
            reset(newUi);
            createGroups.call(self);
            createFields.call(self);
            actions();
            $.ezdia.stickyFormBtns({
                sticky: btnsWrapper,
                frm: frm
            });
            var scrollNavOpt = {
                clickable: true
            };
            if (!newUi) {
                scrollNavOpt.pageHeader = '#ez-page-top-navbar';
                scrollNavOpt.sticky = '#ez-desk-form-actions-wrapper';
            }
            $('#ez-scroll-nav-pills').scrollingNav(scrollNavOpt);
        }
    };
    /**
     * This line of code for support old code.
     * It should be removed in future
     */
    $.ezdia.formConfiguration = ezdia.formConfiguration;
})(ezdia || (ezdia = {}));
